import { settings } from "../../../../settings/settings-util";
import h from "virtual-dom/h";

export default class SurveyDropdownBuilder{
    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildDropdown(dropdownConfig, surveyId){
        const selectedIndex = this.getSelectedIndex();
        const options = dropdownConfig.dropdownOptions.map((item, index) => this.buildDropdownOption(item, index, selectedIndex, surveyId));

        const properties = {
            name: "surveyDropdown",
            className: this._settings.classNames.surveyDropdown || settings.classNames.surveyDropdown,
            ariaLabelledBy: `${surveyId}-title`,
            id: `${surveyId}-survey-dropdown`,
            onchange: this.buildDropdownOnClick(dropdownConfig),
        };

        //using setTimeout 0 allows for the overlay to render before setting the default reason
        setTimeout(function(){
            this.setDefaultReasonAfterRender(dropdownConfig.dropdownOptions);}.bind(this),0);


        return h('select', properties, options);
    }

    buildDropdownOption(option, index, selectedIndex, surveyId){
        const dropdownOptionClassName  = this._settings.classNames.surveyDropdownOption  || settings.classNames.surveyDropdownOption;
        const id = `${surveyId}-survey-reason-${index}`;

        const attributes = { 
            value: option.value, 
            selected: option.selected, 
            id,
            className: dropdownOptionClassName,
            tabIndex: index === selectedIndex ? 0 : -1,
        };

        return h('option', { attributes }, option.text);
    }

    setDefaultReasonAfterRender(options){
        //only set the default reason if the reason is not set
        if(this._store.getState()[this._settings.stateLocations.Survey.Base][this._settings.stateLocations.Survey.Reason] === ""){
            //find the default index
            let selectIndex = 0;
            options.forEach((element, index) => {
                if(element.selected === 'true'){
                    selectIndex = index;
                }
            });

            //dispatch the deafault reason
            this._store.dispatch({ 
                type: "SURVEY_REASON_GIVEN", 
                reason: options[selectIndex].text , 
                selectedReasonIndex: options[selectIndex].value });
        }
    }

    getSelectedIndex()
    {
        const dropdown = document.querySelector('select[name = "surveyDropdown"]');

        if (dropdown) { return dropdown.selectedIndex; }

        return 0;
    }

    buildDropdownOnClick(dropdownConfig){
        return () =>
        {
            const dropdown = document.querySelector('select[name = "surveyDropdown"]');

            if(dropdown)
            {
                const dropdownSelected = dropdown.selectedIndex;
                this._store.dispatch({ 
                    type: "SURVEY_REASON_GIVEN", 
                    reason: dropdownConfig.dropdownOptions[dropdownSelected].text , 
                    selectedReasonIndex: dropdownConfig.dropdownOptions[dropdownSelected].value });
            }
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyDropdownBuilder.js